module.exports = __webpack_public_path__ + "static/media/r337.922390ff.jpg";